// extracted by mini-css-extract-plugin
module.exports = {"slidingBackground":"style_slidingBackground__4_NZD","slide":"style_slide__1Gh6O"};